import { buildMakeUseAxios } from "@api";
import { useCallback } from "react";

const metabaseAxios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}/metabase`);

export const useGetMetabaseDashboard = () => {
  const [state, execute, cancel] = metabaseAxios(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query) => {
      return execute({
        url: `/dashboards${query ? `?${new URLSearchParams(query).toString()}` : ""}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetMetabaseUrl = () => {
  const [state, execute, cancel] = metabaseAxios(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query) => {
      return execute({
        url: `/url${query ? `?${new URLSearchParams(query).toString()}` : ""}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
